import React, { useCallback, useEffect, useState } from 'react';

export interface ICountDown {
  expiredAt: string;
  onChangeSeconds: (seconds: number) => any;
}

function convertMillisecondsToSeconds(milliseconds: number) {
  if (milliseconds <= 0) return 0;
  return Math.floor(milliseconds / 1000);
}

const Countdown: React.FC<ICountDown> = ({ expiredAt, onChangeSeconds }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [endTime, setEndTime] = useState(new Date().getTime() + remainingTime);

  useEffect(() => {
    const nowTime = new Date().getTime();
    // const expiredAtTime = new Date(expiredAt).getTime();
    const expiredAtTime = new Date(expiredAt).getTime();
    const newRemainingTime = expiredAtTime - nowTime;
    setRemainingTime(newRemainingTime);
    setEndTime(nowTime + newRemainingTime);
    setSeconds(convertMillisecondsToSeconds(newRemainingTime));
  }, [expiredAt]);

  const handleOtpChange = useCallback(
    (countDownSeconds: number) => {
      setSeconds(countDownSeconds);
      onChangeSeconds(countDownSeconds);
    },
    [seconds],
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newRemainingTime = Number(endTime - new Date().getTime());

      if (newRemainingTime <= 0) {
        clearInterval(intervalId);
        setRemainingTime(0);
      } else {
        setRemainingTime(newRemainingTime);

        const prevSeconds = seconds;
        const nextSeconds = convertMillisecondsToSeconds(newRemainingTime);

        if (prevSeconds !== nextSeconds) {
          handleOtpChange(nextSeconds);
        }
      }
    });

    return () => clearInterval(intervalId);
  }, [seconds]);

  return <>{seconds} </>;
};

export default Countdown;
